import { ChangeDetectionStrategy, Component, Inject, ViewChild, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { IKidsHotel } from '@mng/mgs-lib';
import { MatButton } from '@angular/material/button';
import { GoogleMap, MapInfoWindow, MapMarker } from '@angular/google-maps';
import { MngOutComponent } from '@mng/mng-base-ui';
import { MngDialogHeaderComponent } from '@mng/mng-inputs';

export interface IKidsGeoMapParams {
  hotel: IKidsHotel;
}

@Component({
  imports: [
    MatDialogActions,
    MatButton,
    MatDialogClose,
    GoogleMap,
    MapMarker,
    MapInfoWindow,
    MngOutComponent,
    MngDialogHeaderComponent
  ],
  templateUrl: './kids-geo-map.component.html',
  styleUrl: './kids-geo-map.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class KidsGeoMapComponent {
  @ViewChild(MapInfoWindow) infoWindow: MapInfoWindow;
  options: google.maps.MapOptions;
  markerPosition: google.maps.LatLngLiteral;

  constructor(
    public dialogRef: MatDialogRef<KidsGeoMapComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IKidsGeoMapParams
  ) {
    this.options = {
      center: { lat: data.hotel.geolat, lng: data.hotel.geolng },
      zoom: 16
    };
    this.markerPosition = { lat: data.hotel.geolat, lng: data.hotel.geolng };
  }

  close() {
    this.dialogRef.close();
  }

  clickMarker(marker: MapMarker) {
    this.infoWindow.open(marker);
  }
}
